export const loginData = () => {
  return [
    {
      id: 'userID',
      name: 'userID',
      label: 'User Name',
      placeholder: 'User Name',
      type: 'string',
      required: 'Enter username',
      match: /^[A-Za-z0-9@._-]+$/,
      matchMessage: 'Enter a valid username',
      trim: true
    },
    {
      id: 'password',
      name: 'password',
      label: 'Password',
      placeholder: 'Password',
      type: 'string',
      required: 'Enter password',
      trim: true
    }
  ];
};
